import { render, staticRenderFns } from "./ChangePlan.vue?vue&type=template&id=18d0447a"
import script from "./ChangePlan.vue?vue&type=script&lang=js"
export * from "./ChangePlan.vue?vue&type=script&lang=js"
import style0 from "./ChangePlan.vue?vue&type=style&index=0&id=18d0447a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports